import type { AdminMinuteProgramEnrollmentsListParams } from "@sidegigllc/api/client";
import { AdminMinuteProgramEnrollmentsListStateItem } from "@sidegigllc/api/client";

/** Mirrors `max_page_size` on the BE's `AdminMinuteEnrollmentPagination`. DRF silently clamps a larger
 * `page_size` down to it, and the pager divides `count` by whatever is declared here — so overstating it
 * computes one page for a queue that has several, which is how rows past the 50th became unreachable
 * (TS-7091). */
export const PAGE_SIZE = 50;

// `satisfies` rather than `as const`: `as const` makes `state` readonly, which the generated params
// type (a mutable array) will not accept.
const BASE_LIST_PARAMS = {
  state: [AdminMinuteProgramEnrollmentsListStateItem.interest_submitted],
  page_size: PAGE_SIZE,
} satisfies AdminMinuteProgramEnrollmentsListParams;

export type ListParams = typeof BASE_LIST_PARAMS & { page: number };

/** Built in one place because the params are the react-query key the bulk actions' optimistic patch and
 * rollback address — the key the table reads and the key the mutation writes have to be identical. */
export const listParamsForPage = (page: number): ListParams => ({ ...BASE_LIST_PARAMS, page });
